import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComandaDetalharComponent } from './comanda-detalhar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: ComandaDetalharComponent}
  ])],
  exports: [RouterModule]
})
export class ComandaDetalharRoutingModule { }
